import { render, staticRenderFns } from "./NickDialogComponent.vue?vue&type=template&id=8cd159a4&scoped=true"
import script from "./NickDialogComponent.vue?vue&type=script&lang=js"
export * from "./NickDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd159a4",
  null
  
)

export default component.exports